import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const CTASection = ({ onGetStarted, onContactSales }) => {
  return (
    <section className="py-16 md:py-24 lg:py-32 bg-gradient-to-br from-primary via-primary/90 to-secondary">
      <div className="max-w-5xl mx-auto px-4 md:px-6 lg:px-8 text-center">
        <div className="mb-8 md:mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full mb-6">
            <Icon name="Sparkles" size={20} className="text-white" />
            <span className="text-white font-medium">Limited Time Offer</span>
          </div>

          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4 md:mb-6">
            Get Your First Report Free
          </h2>

          <p className="text-base md:text-lg lg:text-xl text-white/90 max-w-2xl mx-auto mb-8 md:mb-10">
            Start with a complimentary AI-powered preliminary fire forensics assessment.
            Verify your email and add a payment method to unlock your free report.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8 md:mb-12">
          <Button
            variant="default"
            size="xl"
            iconName="ArrowRight"
            iconPosition="right"
            onClick={onGetStarted}
            className="bg-white text-primary hover:bg-white/90 w-full sm:w-auto"
          >
            Start Free Report Now
          </Button>
          <Button
            variant="outline"
            size="xl"
            iconName="Phone"
            iconPosition="left"
            onClick={onContactSales}
            className="border-white text-white hover:bg-white/10 w-full sm:w-auto"
          >
            Talk to Sales
          </Button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 max-w-3xl mx-auto">
          <div className="flex flex-col items-center gap-2">
            <Icon name="Clock" size={32} className="text-white mb-2" />
            <span className="text-white font-semibold">Fast Turnaround</span>
            <span className="caption text-white/80">Typical report time varies by case</span>
          </div>

          <div className="flex flex-col items-center gap-2">
            <Icon name="Shield" size={32} className="text-white mb-2" />
            <span className="text-white font-semibold">Security-First Design</span>
            <span className="caption text-white/80">Encryption and access controls</span>
          </div>

          <div className="flex flex-col items-center gap-2">
            <Icon name="Award" size={32} className="text-white mb-2" />
            <span className="text-white font-semibold">Standards-Informed</span>
            <span className="caption text-white/80">Structured to align with industry practices</span>
          </div>
        </div>

        <p className="mt-8 text-sm text-white/75 max-w-3xl mx-auto">
          Note: Reports are AI-generated preliminary assessments for informational purposes only and are not a substitute
          for a licensed on-site investigation or legal advice.
        </p>
      </div>
    </section>
  );
};

export default CTASection;
